import React from 'react';
import DialogInput from 'screens/components/advanced/DialogInput';
import Button from 'screens/components/basic/Button';
import DialogHeader from 'screens/components/basic/DialogHeader';
import { Link } from 'react-router-dom';

class CashCountDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };

        this.handleToggle = this.handleToggle.bind(this);
    }

    handleToggle() {
        this.setState({ open: !this.state.open });
    }

    changePage(e) {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        })
    }

    getType = (type) => {
        switch (type) {
            case 1:
                return "Cash In"
            case 2:
                return "Cash Drop"
            case 3:
                return "Cash Out"
        }

    }

    render() {
        let cashCount = this.props.cashCount;
        let type = 0;
        let hundredCount = 0;
        let fiftyCount = 0;
        let twentyCount = 0;
        let tenCount = 0;
        let fiveCount = 0;
        let twoCount = 0;
        let oneCount = 0;
        let twentyFiveCoinCount = 0;
        let tenCoinCount = 0;
        let fiveCoinCount = 0;

        if (cashCount != null) {
            type = this.getType(cashCount.type)
            hundredCount = cashCount.hundredCount ? cashCount.hundredCount : 0;
            fiftyCount = cashCount.fiftyCount ? cashCount.fiftyCount : 0;
            twentyCount = cashCount.twentyCount ? cashCount.twentyCount : 0;
            tenCount = cashCount.tenCount ? cashCount.tenCount : 0;
            fiveCount = cashCount.fiveCount ? cashCount.fiveCount : 0;
            twoCount = cashCount.twoCount ? cashCount.twoCount : 0;
            oneCount = cashCount.oneCount ? cashCount.oneCount : 0;
            twentyFiveCoinCount = cashCount.twentyFiveCoinCount ? cashCount.twentyFiveCoinCount : 0;
            tenCoinCount = cashCount.tenCoinCount ? cashCount.tenCoinCount : 0;
            fiveCoinCount = cashCount.fiveCoinCount ? cashCount.fiveCoinCount : 0;
        }

        return (
            <Link onClick={this.handleToggle}>
                <span className="text-info">View</span>
                <DialogInput
                    title={<DialogHeader text={`${type} ${this.props.time}`} />}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancel"
                            className="btn-space"
                            label="Cancel"
                            onTouchTap={() => this.handleToggle()} />
                    ]}
                    modal={true}
                    handleClose={() => this.handleToggle()}
                    open={this.state.open}
                    autoScrollBodyContent
                >
                    <h4>Count for {type} at {this.props.time}</h4>
                    <table className="table table-striped table-hover table-responsive">
                        <thead>
                            <tr>
                                <th>Denomination</th>
                                <th>Count</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>$100</td>
                                <td>{hundredCount}</td>
                                <td>$ {(hundredCount * 100).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>$50</td>
                                <td>{fiftyCount}</td>
                                <td>$ {(fiftyCount * 50).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>$20</td>
                                <td>{twentyCount}</td>
                                <td>$ {(twentyCount * 20).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>$10</td>
                                <td>{tenCount}</td>
                                <td>$ {(tenCount * 10).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>$5</td>
                                <td>{fiveCount}</td>
                                <td>$ {(fiveCount * 5).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>$2</td>
                                <td>{twoCount}</td>
                                <td>$ {(twoCount * 2).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>$1</td>
                                <td>{oneCount}</td>
                                <td>$ {(oneCount * 1).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>25c</td>
                                <td>{twentyFiveCoinCount}</td>
                                <td>$ {(twentyFiveCoinCount * 0.25).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>10c</td>
                                <td>{tenCoinCount}</td>
                                <td>$ {(tenCoinCount * 0.1).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>5c</td>
                                <td>{fiveCoinCount}</td>
                                <td>$ {(fiveCoinCount * 0.05).toFixed(2)}</td>
                            </tr>
                        </tbody>
                    </table>
                </DialogInput>
            </Link>

        );
    }
}

export default CashCountDialog;